import { IStore } from "../types";
import { IPayment } from "./types";

export function getPayments({ payment }: IStore): IPayment[] {
  return payment ? payment.payments : [];
}
